module.exports = __webpack_public_path__ + "img/Reg-3-GlobalPersp.b60ae26f.svg";